import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular/lazy';
import { App, AppInfo } from '@capacitor/app';

@Injectable({ providedIn: 'root' })
export class VersionService {
  private versionNumber = '';

  constructor(
    // private readonly appVersion: AppVersion,
    private readonly platform: Platform
  ) {}

  public getVersion(): string {
    return this.versionNumber;
  }

  public fetch(): Promise<string> {
    if (this.versionNumber) {
      return Promise.resolve(this.versionNumber);
    }
    return App.getInfo().then((info: AppInfo) => (this.versionNumber = info.version));
  }
}
